

import React from 'react';
import { Letter } from '../../types/letterGraph';

interface LetterInfoPanelProps {
    letter: Letter;
    onClose: () => void;
}

const LetterInfoPanel: React.FC<LetterInfoPanelProps> = ({ letter, onClose }) => {
    return (
        <div style={{
            width: 400,
            background: '#f9fafb',
            border: '1px solid #e5e7eb',
            borderLeft: 'none',
            borderRadius: '0 8px 8px 0',
            padding: '20px',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {/* Заголовок панели */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h4 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Информация о письме</h4>
                <button
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: 20,
                        cursor: 'pointer',
                        color: '#6b7280',
                        padding: 0,
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    aria-label="Закрыть"
                >
                    ×
                </button>
            </div>

            {/* Список полей письма */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {/* Номер письма */}
                <div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Номер</div>
                    <div style={{ fontSize: 14, fontWeight: 500 }}>{letter.number}</div>
                </div>

                {/* Тип письма */}
                <div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Тип</div>
                    <div style={{ fontSize: 14 }}>{letter.letter_type}</div>
                </div>

                {/* Дата */}
                <div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Дата</div>
                    <div style={{ fontSize: 14 }}>{new Date(letter.date).toLocaleDateString('ru-RU')}</div>
                </div>

                {/* Тема (если есть) */}
                {letter.subject && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Тема</div>
                        <div style={{ fontSize: 14 }}>{letter.subject}</div>
                    </div>
                )}

                {/* Организация (если есть) */}
                {letter.organization && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Организация</div>
                        <div style={{ fontSize: 14 }}>{letter.organization}</div>
                    </div>
                )}

                {/* Кому (организация) (если есть) */}
                {letter.to_organization && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Кому (организация)</div>
                        <div style={{ fontSize: 14 }}>{letter.to_organization}</div>
                    </div>
                )}

                {/* Кому (лицо) (если есть) */}
                {letter.to_person && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Кому (лицо)</div>
                        <div style={{ fontSize: 14 }}>{letter.to_person}</div>
                    </div>
                )}

                {/* От кого (если есть) */}
                {letter.from_person && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>От кого</div>
                        <div style={{ fontSize: 14 }}>{letter.from_person}</div>
                    </div>
                )}

                {/* Ответственный (если есть) */}
                {letter.responsible_employee && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Ответственный</div>
                        <div style={{ fontSize: 14 }}>{letter.responsible_employee}</div>
                    </div>
                )}

                {/* Автор записи (если есть) */}
                {letter.created_by && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Создано</div>
                        <div style={{ fontSize: 14 }}>{letter.created_by}</div>
                    </div>
                )}

                {/* Email получателя (если есть) */}
                {letter.email_receiver && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Email получателя</div>
                        <div style={{ fontSize: 14 }}>{letter.email_receiver}</div>
                    </div>
                )}

                {/* Email отправителя (если есть) */}
                {letter.email_sender && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Email отправителя</div>
                        <div style={{ fontSize: 14 }}>{letter.email_sender}</div>
                    </div>
                )}

                {/* Внешний исполнитель (если есть) */}
                {letter.external_executor && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Внешний исполнитель</div>
                        <div style={{ fontSize: 14 }}>{letter.external_executor}</div>
                    </div>
                )}

                {/* Примечание (если есть) */}
                {letter.note && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Примечание</div>
                        <div style={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>{letter.note}</div>
                    </div>
                )}

                {/* Внешняя информация (если есть) */}
                {letter.external_letter_info && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Внешняя информация</div>
                        <div style={{ fontSize: 14 }}>{letter.external_letter_info}</div>
                    </div>
                )}

                {/* Родительское письмо (если есть) */}
                {letter.parent_number && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Родительское письмо</div>
                        <div style={{ fontSize: 14 }}>{letter.parent_number}</div>
                    </div>
                )}

                {/* Последнее обновление (если есть) */}
                {letter.last_updated && (
                    <div>
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Последнее обновление</div>
                        <div style={{ fontSize: 14 }}>{new Date(letter.last_updated).toLocaleDateString('ru-RU')}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LetterInfoPanel;

